import "./VorViewer.css";

import { lazy, Suspense, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import AlertLoading from "components/AlertLoading";
import { ResourceMappingModal } from "pages/ResourceSheet/components/resourceMappingModal/ResourceMappingModal";
import { getClickedTableRow, setCurrentEstmDocId, setCurrentPage } from "slices/ribbon";
import { fetchVorViewerData } from "slices/vor/services/fetchVorViewerData";
import {
	getVorConnectedLsrItemModalTableData,
	getVorConnectedLsrItemModalVisible,
	getVorFetchStatus,
	getVorFetchStatusText,
} from "slices/vor/vorSelectors";
import { vorActions } from "slices/vor/vorSlice";

import VorEmpty from "./components/VorEmpty/VorEmpty";
import VorFooterSignatures from "./components/VorFooterSignatures/VorFooterSignatures";
import VorHeader from "./components/VorHeader/VorHeader";
import VorTable from "./components/VorTable/VorTable";
import useVorFuncs from "./useVorFuncs";

const PdfPreviewModel = lazy(() => import("components/PdfPreviewModel"));

const VorViewer = ({ scrollBlock }) => {
	const dispatch = useDispatch();

	const fetchStatus = useSelector(getVorFetchStatus);
	const fetchStatusText = useSelector(getVorFetchStatusText);
	const clickedTableRow = useSelector(getClickedTableRow);
	const [justPdfVisible, setJustPdfVisible] = useState(false);
	const [pdfBlobData, setPdfBlobData] = useState(null);
	const [pdfBlobName, setPdfBlobName] = useState("file.pdf");
	const [pdfTargetPage, setTargetPage] = useState(0);

	const connectedLsrItemModalVisible = useSelector(getVorConnectedLsrItemModalVisible);
	const connectedLsrItemModalTableData = useSelector(getVorConnectedLsrItemModalTableData);

	const { vorId } = useParams();

	const { getJust } = useVorFuncs({ vorId, setPdfBlobData, setPdfBlobName, setJustPdfVisible, setTargetPage });

	const headBlock1 = useRef();
	const headBlock2 = useRef();

	useEffect(() => {
		dispatch(setCurrentPage("VorViewer"));
		if (!vorId) {
			dispatch(setCurrentEstmDocId(null));
			return;
		}
		dispatch(fetchVorViewerData({ vorId }));
		dispatch(setCurrentEstmDocId(vorId));
	}, [vorId, dispatch]);

	if (!vorId) return <VorEmpty />;

	return (
		<div className="TableOuterBox" type="VorViewer">
			<div className="VorViewerLayout">
				<VorHeader refBlocks={{ headBlock1, headBlock2 }} />
				<VorTable scrollBlock={scrollBlock} upperFuncs={{ getJust }} />
				<VorFooterSignatures />
				<AlertLoading fetchStatus={fetchStatus} fetchStatusText={fetchStatusText} func={vorActions.setFetchStatus} />
				{justPdfVisible && (
					<Suspense>
						<PdfPreviewModel blobData={pdfBlobData} blobName={pdfBlobName} setVisible={setJustPdfVisible} targetPage={pdfTargetPage} />
					</Suspense>
				)}
				{connectedLsrItemModalVisible && (
					<ResourceMappingModal
						setResourceMappingModalVisible={(arg) => dispatch(vorActions.setConnectedLsrItemsModalVisible(arg))}
						tableData={connectedLsrItemModalTableData}
						setTableData={(arg) => dispatch(vorActions.setConnectedLsrItemModalTableData(arg))}
						ResourceMappingItem={clickedTableRow}
						hideProject={true}
					/>
				)}
			</div>
		</div>
	);
};

export default VorViewer;
